<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div
    v-if="resultadoValidacao && resultadoValidacao['resumo'] && resultadoValidacao['resumo']['qtd_conjuntos']"
    class="table-container"
  >
    <table v-if="!transporMatriz" cellspacing="0" border="0">
      <tr>
        <td class="celula-conj">CONJ</td>
        <td v-for="conj in resultadoValidacao['conj']" :key="conj" class="celula-conj">
          {{ conj }}
        </td>
      </tr>
      <tr v-for="mes in meses" v-if="exibirNumCons" :key="`num_cons_${mes}`">
        <td
          :style="{
            background: '#BDD7EE',
            color: '#000000'
          }"
        >
          NUM_CONS_{{ mes }}
        </td>
        <td v-for="(conj, i) in resultadoValidacao['conj']" :key="i" :title="`NUM_CONS_${mes} do CONJ ${conj}`">
          {{ resultadoValidacao[`nuc_${mes}`]['num_cons'][i] | parseNumberToFloatBR }}
        </td>
      </tr>
      <tr v-for="mes in meses" v-if="exibirNucInd" :key="`nuc_ind_${mes}`">
        <td
          :style="{
            background: '#203864',
            color: '#ffffff'
          }"
        >
          NUC_IND_{{ mes }}
        </td>
        <td v-for="(conj, i) in resultadoValidacao['conj']" :key="i" :title="`NUC_IND_${mes} do CONJ ${conj}`">
          {{ resultadoValidacao[`nuc_${mes}`]['nuc_ind'][i] | parseNumberToFloatBR }}
        </td>
      </tr>
      <tr v-for="mes in meses" :key="`nuc_${mes}_perc`">
        <td
          :style="{
            background: '#BDD7EE',
            color: '#000000'
          }"
        >
          NUC_{{ mes }}_PERC
        </td>
        <td
          v-for="(conj, i) in resultadoValidacao['conj']"
          :key="i"
          :title="`NUC_${mes}_PERC do CONJ ${conj}`"
          :style="{
            background: getBackgroundColorByStatus(resultadoValidacao[`nuc_${mes}`]['status'][i]),
            color: getTextColorByStatus(resultadoValidacao[`nuc_${mes}`]['status'][i])
          }"
        >
          <span v-if="statusConjuntos">
            <status-validacao :status="resultadoValidacao[`nuc_${mes}`]['status'][i]" />
          </span>
          <span v-else>
            {{ resultadoValidacao[`nuc_${mes}`]['perc'][i] | parseNumberToFloatBR }}
          </span>
        </td>
      </tr>
    </table>
    <table v-if="transporMatriz" cellspacing="0" border="0">
      <tr>
        <td class="celula-conj">CONJ</td>
        <td
          v-for="mes in meses"
          v-if="exibirNumCons"
          :key="`num_cons_${mes}`"
          :style="{
            background: '#BDD7EE',
            color: '#000000'
          }"
        >
          NUM_CONS_{{ mes }}
        </td>
        <td
          v-for="mes in meses"
          v-if="exibirNucInd"
          :key="`nuc_ind_${mes}`"
          :style="{
            background: '#203864',
            color: '#ffffff'
          }"
        >
          NUC_IND_{{ mes }}
        </td>
        <td
          v-for="mes in meses"
          :key="`nuc_${mes}_perc`"
          :style="{
            background: '#BDD7EE',
            color: '#000000'
          }"
        >
          NUC_{{ mes }}_PERC
        </td>
      </tr>
      <tr v-for="(conj, i) in resultadoValidacao['conj']" :key="conj">
        <td class="celula-conj">
          {{ conj }}
        </td>
        <td v-for="mes in meses" v-if="exibirNumCons" :key="`num_cons_${mes}`" :title="`NUM_CONS_${mes} do CONJ ${conj}`">
          {{ resultadoValidacao[`nuc_${mes}`]['num_cons'][i] | parseNumberToFloatBR }}
        </td>
        <td v-for="mes in meses" v-if="exibirNucInd" :key="`nuc_ind_${mes}`" :title="`NUC_IND_${mes} do CONJ ${conj}`">
          {{ resultadoValidacao[`nuc_${mes}`]['nuc_ind'][i] | parseNumberToFloatBR }}
        </td>
        <td
          v-for="mes in meses"
          :key="`nuc_${mes}_perc`"
          :title="`NUC_${mes}_PERC do CONJ ${conj}`"
          :style="{
            background: getBackgroundColorByStatus(resultadoValidacao[`nuc_${mes}`]['status'][i]),
            color: getTextColorByStatus(resultadoValidacao[`nuc_${mes}`]['status'][i])
          }"
        >
          <span v-if="statusConjuntos">
            <status-validacao :status="resultadoValidacao[`nuc_${mes}`]['status'][i]" />
          </span>
          <span v-else>
            {{ resultadoValidacao[`nuc_${mes}`]['perc'][i] | parseNumberToFloatBR }}
          </span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  import TabelaResultadoValidacaoMixins from './TabelaResultadoValidacaoMixins';
  import StatusValidacao from './StatusValidacao.vue';
  export default {
    name: 'TabelaResultadoValidacaoNuc',
    components: { StatusValidacao },
    mixins: [TabelaResultadoValidacaoMixins],
    props: {
      exibirNumCons: {
        type: Boolean,
        default: false
      },
      exibirNucInd: {
        type: Boolean,
        default: false
      }
    }
  };
</script>

<style>
  .table-container {
    max-width: 100%;
    overflow-x: scroll;
    padding-bottom: 20px;
  }
  .table-container table td {
    font-family: 'Times New Roman', Times, serif;
    font-size: 12px;
    border: 1px solid #000000;
    padding: 5px;
    text-align: center;
  }
  .celula-conj {
    background-color: #ffe699;
    font-weight: bold;
    text-align: center;
  }
</style>
